import React from 'react';
import Layout from './Layout';
import { useDataAdmission } from '../contexts/DataAdmissionContext';

interface DataSourceLayoutProps {
    children: React.ReactNode;
    // Report metadata for feedback modal (passed from report page)
    currentReportId?: string;
    currentReportName?: string;
}

/**
 * Layout wrapper that provides data sources and folders to the header search functionality.
 * Data is sourced from DataAdmissionContext (single shared fetch).
 */
const DataSourceLayout: React.FC<DataSourceLayoutProps> = ({ children, currentReportId, currentReportName }) => {
    const { dataSources, folders } = useDataAdmission();

    return (
        <Layout
            allDataSources={dataSources}
            folders={folders}
            currentReportId={currentReportId}
            currentReportName={currentReportName}
        >
            {children}
        </Layout>
    );
};

export default DataSourceLayout;